// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"4163ee13","391":"7c0f7964","646":"0b095fef","787":"90c5de79","997":"d95f5da1"}[chunkId] + ".chunk.js";
};